$ = jQuery.noConflict();
$(document).on("click", ".klaviyo_form_trigger", function(evt) {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(["openForm", "TXLwTh"]);
});

  






/ PDP Scripts Slider Section /;
var thumbOptions = {
    slidesToShow: 5,
    slideToScroll: 1,
    arrows: true,
    responsive: [{
        breakpoint: 767,
        settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            centerMode: true,
            focusOnSelect: true,
            arrows: false,
        },
    }, ],
};
const thumbSlider = $(".product-images-thumb-slider");
thumbSlider.slick(thumbOptions);
$(".product-images-thumb-list").show();
thumbSlider.on("afterChange", function(event, slick, currentSlide, nextSlide) {
    var CurrentSlideDom = $(".product-images-thumb-slider .slick-slide.slick-current.slick-active").find(".thumb-image").attr("href");
    $(".product-featured-image .product-f-image").attr("src", CurrentSlideDom);
});
$(document).on("click", ".thumb-image", function() {
    $(".product-featured-image .product-f-image").attr("src", $(this).attr("href"));
});
$(".accordion-pdp").click(function() {
    id = $(this).attr("href");
    $("html, body").animate({
        scrollTop: $(id).offset().top,
    }, 2000);
});
if ($("[data-fancybox]").length > 0) {
    $("[data-fancybox]").fancybox();
}
/ PDP video Testimonials /;

function UpdateContents(elm) {
    var parent = $(elm).parents(".single-testimonial");
    if (parent.length > 0) {
        var reviewrName = parent.data("revier-name");
        var description = parent.find(".review-description").text();
        $(".person-title").text(reviewrName);
        $(".person-review").text(description);
        $(".watch-video").attr("data-index", parent.attr("data-index"));
    }
}
$(document).on("click", ".r-info", function() {
    UpdateContents(this);
});
$(document).on("click", ".watch-video", function(evt) {
    evt.preventDefault();
    var videoIndex = $(this).attr("data-index");
    $("#main-player--" + videoIndex).click();
});

function ClosePreviousVideos() {
    $(".pdp-videos").each(function(index, videoTag) {
        var vid = $(videoTag).attr("id");
        console.log(vid)
        if (vid != "") {
            var Singlevideo = document.getElementById(vid);
            Singlevideo.controls = false;
            Singlevideo.pause();
            var playIcon = $(videoTag).parents(".testimonial-image").find(".play-icon") || $(videoTag).parents(".testimonial-video").find(".play-icon");
            $(playIcon).show();
            $(".single-testimonial").removeClass("zoomed-in");
        }
    });
}

function CloseMobilePlay() {
    $(".pdp-videos").each(function(index, videoTag) {
        var vid = $(videoTag).attr("id");
        var Singlevideo = document.getElementById(vid);
        Singlevideo.controls = false;
        Singlevideo.pause();
        var playIcon = $(videoTag).parents(".testimonial-video").find(".play-icon");
        $(playIcon).show();
        $(".single-testimonial").removeClass("zoomed-in");
    });
}
$(document).on("click", ".play-icon", function() {
    $(this).hide();
    ClosePreviousVideos();
    var playIcon = this;
    UpdateContents(this);
    var vid = $(this).data("video");
    var myVideo = document.getElementById(vid);
    myVideo.play();
    myVideo.controls = true;
    var parent = $(this).parents(".single-testimonial");
    var lastClildIndex = $(".testimoials-list .single-testimonial:last").attr("data-index");
    var parentIndex = $(parent).attr("data-index");
    $(".testimonial-person-info").removeClass("playing-video-info");
    myVideo.addEventListener("ended", function() {
        var videoTag = this;
        myVideo.controls = false;
        $(playIcon).show();
        $(parent).removeClass("zoomed-in");
        $(".testimonial-person-info").removeClass("playing-video-info");
        $(myVideo).removeClass("i-am-playing");
    }, false);
    myVideo.addEventListener("play", (event) => {
        $(".single-testimonial").removeClass("zoomed-in");
        $(playIcon).hide();
        $(parent).addClass("zoomed-in");
        $(myVideo).addClass("i-am-playing");
        if (lastClildIndex == parentIndex) {
            $(".testimonial-person-info").addClass("playing-video-info");
        }
    });
});
window.onresize = function(event) {
    applyOrientation();
};

function applyOrientation() {
    if (window.ReviewVideosSlider) {
        window.ReviewVideosSlider.slick("unslick");
        window.ReviewVideosSlider.slick("refresh");
        ApplyCeterModeSlick();
    }
}
ApplyCeterModeSlick();

function ApplyCeterModeSlick() {
    if ($(window).width() < 1200) {
        window.ReviewVideosSlider = $(".mobile-video-testimonials").not('.slick-initialized').slick({
            slidesToShow: 2,
            slidesToScroll: 1,
            focusOnSelect: true,
            infinite: false,
            // centerMode: true,
            responsive: [{
                breakpoint: 900,
                settings: {
                    slidesToShow: 2,
                    centerMode: false,
                    slidesToScroll: 1,
                },
            }, {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            }, {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            }, ],
        });
        window.ReviewVideosSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            CloseMobilePlay()
        });
    }
}
/ Recommended Product Script PDP /;
window.ApplySlickOnRecommendedProducts = function() {
    if ($(".product-recommendations-section-pdp .product-grid").length > 0) {
        var slidesInTheList = $(".product-recommendations-section-pdp .recom-p-list").length;
        var FeaturedProductSlider = $(".to-be-slider");
        FeaturedProductSlider.slick({
            dots: false,
            infinite: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    adaptiveHeight: true,
                },
            }, {
                breakpoint: 769,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            }, ],
        });
        // var progressBar = $(".product-recommendations-section-pdp  .Pagination-module_bar");
        // progressBar.css("width", 100 / slidesInTheList + "%");
        // var allwidth = 100 - 100 / slidesInTheList;
        // $(".to-be-slider").addClass("hide-prev");
        // FeaturedProductSlider.on("beforeChange", function(event, slick, currentSlide, nextSlide) {
        //     var calc = (nextSlide / slick.slideCount) * 100;
        //     var pixels = slick.slideCount - 1 == nextSlide ? allwidth + "%" : (calc * $(window).width()) / 100 + "px";
        //     progressBar.css("left", pixels);
        //     if (calc > 0) {
        //         $(".to-be-slider").removeClass("hide-prev");
        //     } else {
        //         $(".to-be-slider").addClass("hide-prev");
        //     }
        //     if (slick.slideCount - 1 == nextSlide) {
        //         $(".to-be-slider").addClass("hide-next");
        //     } else {
        //         $(".to-be-slider").removeClass("hide-next");
        //     }
        // });
        // window.UpdateFormsAsPerCountry();
    }
};
window.UpdateCustomOptions = function(rplist) {
    var cnt = $(rplist).find(".pricing-script").length;
    window.sccount = 0;
    $(rplist).find(".recom-p-list").each(function(index, rproduct) {
        var script = $(rproduct).find(".ctm-script").html();
        eval(script);
        $(rproduct).find(".pricing-script").each(function(i, ps) {
            var pscript = $(ps).html();
            try {
                eval(pscript);
                window.sccount++;
                // console.log(window.sccount, cnt);
            } catch (e) {
                if (e instanceof SyntaxError) {
                    console.log(e.message);
                }
            }
        });
    });
    if (window.sccount == cnt) {
        window.makeFirstOptionSelected();
    }
};
window.makeFirstOptionSelected = function() {
    $(".product-recommendations ").find(".single-option.Size").each(function(index, swatch) {
        if ($(swatch).find(".swatch-wrapper").length > 0) {
            if ($(swatch).find(".swatch-wrapper").length == 1) {
                var swSelector = $(swatch).find(".swatch-wrapper:first").find("input");
            } else {
                var swSelector = $(swatch).find(".swatch-wrapper:eq(1)").find("input");
            }
            swSelector.click();
        }
    });
};
if ($(window).width() > 960) {
    $(document).on({
        mouseenter: function() {
            $(this).addClass("show-arrows");
        },
        mouseleave: function() {
            $(this).removeClass("show-arrows");
        },
    }, ".to-be-slider");
    $(document).on({
        mouseenter: function() {
            $(this).addClass("show-atc");
        },
        mouseleave: function() {
            $(this).removeClass("show-atc");
        },
    }, ".recom-p-list");
}
/ Sticky Add To cart JS/;
$(window).scroll(function() {
    if ($(".benefits").length > 0) {
        if ($(window).scrollTop() > $(".benefits").offset().top) {
            $(".sticky-add-to-cart").show();
        } else {
            $(".sticky-add-to-cart").hide();
        }
    }
});


$(document).on("click", ".close-sticky-atc", function() {
  console.log("Hello");
  $(".atc-frm-container").slideToggle("slow");
  $(".sticky-add-to-cart").toggleClass('opened')
})
$(document).on("click", ".mobile-qty-buttons .sticty-qty-btns", function() {
    // alert("Hi Clicked")
    var form = $(this).parents(".sticky-add-to-cart").find("form");
    if ($(this).hasClass("plus")) {
        form.find(".add-up.add-action").click();
    } else {
        form.find(".add-down.add-action").click();
    }
    var qty = JSON.parse(form.find("[name=quantity]").val());
    $(".mobile-qty-buttons").find("[name=quantity]").val(qty);
});
/ Collection Page Scripts/;
$(document).ready(function() {
    $(document).on("click", ".open-filter", function() {
        $("#FacetFiltersForm").slideToggle();
        $(this).closest(".open-filter-li").toggleClass("opened");
        if ($(window).width() < 600) {
            $(".mobile-facets__open").click();
        }
    });
});




/ FAQ Page Scripts/;
var faqCloseIcon = $(".faq-page .close-icon");
var defaultText = "Hello, How Can We Help?";
window.generateSearchHtml = function(arr) {
    var Html = "";
    for (i = 0; i < arr.length; i++) {
        var yourArray = arr[i];
        Html += '<div class="single-searched-answer">';
        Html += '<div class="found-question">Answer : ' + (i + 1) + " " + yourArray.question + "</div>";
        Html += '<div class="found-answer">' + yourArray.answer + "</div>";
        Html += "</div>";
    }
    $(".search-found-list").html(Html);
    $("#count-heading").html(arr.length + " Results Found For " + "“" + $("#search-field-faq").val() + "”");
    $("html, body").animate({
        scrollTop: $(".faq-questions-list-searched").offset().top,
    }, 2000);
};
window.ReinitiateTextBox = function() {
    $("#count-heading").html(defaultText);
};
window.ShowSearchResults = function() {
    var keyword = $("#search-field-faq").val().toLowerCase();
    var arr = window.FaqObj.arrayQuestionsList;
    var FoundList = [];
    for (i = 0; i < arr.length; i++) {
        var yourArray = arr[i];
        var isInList = yourArray.topic.toLowerCase().indexOf(keyword) > -1 || yourArray.question.toLowerCase().indexOf(keyword) > -1 || yourArray.answer.toLowerCase().indexOf(keyword) > -1;
        if (isInList) {
            FoundList.push(yourArray);
        }
    }
    if (FoundList.length > 0) {
        $(".faq-questions-list-searched").show();
        window.generateSearchHtml(FoundList);
    } else {
        $(".faq-questions-list-searched").hide();
        window.ReinitiateTextBox();
    }
    var x = document.getElementsByClassName("autocomplete-items");
    for (var i = 0; i < x.length; i++) {
        x[i].parentNode.removeChild(x[i]);
    }
};
window.ShowClickedResults = function() {
    var keyword = handelize($("#search-field-faq").val());
    var index = window.FaqObj.HadelizeObj[keyword].index;
    var checkbox = $("#faq_checkbox_" + index);
    checkbox.closest(".tab").removeClass("display-none-class");
    $("html, body").animate({
        scrollTop: checkbox.parents(".tab").offset().top - 100,
    }, 2000);
    checkbox.click();
};
window.ClearValues = function() {
    $(".tab:gt(5)").addClass("display-none-class");
    $(".faq-questions-list-searched").hide();
    window.ReinitiateTextBox();
};
String.prototype.replaceBetween = function(start, end, what) {
    return this.substring(0, start) + what + this.substring(end);
};

function autocomplete(inp, arr) {
    inp.addEventListener("input", function(e) {
        var a,b,i,val = this.value;
        closeAllLists();
        faqCloseIcon.addClass("visible");
        if (!val) {
            window.ClearValues();
            faqCloseIcon.removeClass("visible");
            return false;
        }
        currentFocus = -1;
        a = document.createElement("DIV");
        a.setAttribute("id", this.id + "autocomplete-list");
        a.setAttribute("class", "autocomplete-items");
        this.parentNode.appendChild(a);
        for (i = 0; i < arr.length; i++) {
            var loweArr = arr[i].toLowerCase();
            var KW = val.toLowerCase();
            if (loweArr.indexOf(KW) > -1) {
                var IndexAtWhich = loweArr.indexOf(KW);
                var endIndex = IndexAtWhich + KW.length;
                b = document.createElement("DIV");
                b.innerHTML += loweArr.replaceBetween(IndexAtWhich, endIndex, "<b>" + arr[i].substring(IndexAtWhich, endIndex) + "</b>");
                b.innerHTML += "<input type='hidden' value='" + arr[i] + "'>";
                b.addEventListener("click", function(e) {
                    inp.value = this.getElementsByTagName("input")[0].value;
                    window.ShowClickedResults();
                    closeAllLists();
                });
                a.appendChild(b);
            }
        }
    });
    inp.addEventListener("keydown", function(e) {
        var x = document.getElementById(this.id + "autocomplete-list");
       var val = this.value;
        if (x) x = x.getElementsByTagName("div");
      $(".empty-field-error").hide();
        // close-icon.visible
        if (e.keyCode == 40) {
            currentFocus++;
            addActive(x);
        } else if (e.keyCode == 38) {
            currentFocus--;
            addActive(x);
        } else if (e.keyCode == 13) {
            e.preventDefault();
            if(val != ''){
               window.ShowSearchResults();
            }else{
              $(".empty-field-error").show();
            }
            if (currentFocus && currentFocus > -1) {
                if (x) x[currentFocus].click();
            }
        }
    });

    function addActive(x) {
        if (!x) return false;
        removeActive(x);
        if (currentFocus >= x.length) currentFocus = 0;
        if (currentFocus < 0) currentFocus = x.length - 1;
        x[currentFocus].classList.add("autocomplete-active");
    }

    function removeActive(x) {
        for (var i = 0; i < x.length; i++) {
            x[i].classList.remove("autocomplete-active");
        }
    }

    function closeAllLists(elmnt) {
        var x = document.getElementsByClassName("autocomplete-items");
        for (var i = 0; i < x.length; i++) {
            if (elmnt != x[i] && elmnt != inp) {
                x[i].parentNode.removeChild(x[i]);
            }
        }
    }
    document.addEventListener("click", function(e) {
        closeAllLists(e.target);
    });
}

function removeDuplicates(arr) {
    return arr.filter((item, index) => arr.indexOf(item) === index);
}
if (window.Questions) {
    window.FaqObj.questionsList = removeDuplicates(window.FaqObj.questionsList);
    $(".faq-que-ans-list .tabs").append(window.FaqObj.ExtraFaqs);
    autocomplete(document.getElementById("search-field-faq"), window.FaqObj.questionsList);
}

function gup(name, url) {
    if (!url) url = location.href;
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regexS = "[\\?&]" + name + "=([^&#]*)";
    var regex = new RegExp(regexS);
    var results = regex.exec(url);
    return results == null ? null : results[1];
}
if (gup("topic")) {
    var topic = handelize(gup("topic"));
    if (TopicsObj[topic] && TopicsObj[topic].length > 0) {
        $(".single-popular-topic a:eq(6)").click();
    }
}
$(document).on("click", ".faq-page .close-icon", function(e) {
    faqCloseIcon.removeClass("visible");
});
$(document).on("click", ".single-popular-topic a", function(e) {
    e.preventDefault();
    $(".single-popular-topic").removeClass("selected");
    $(this).parents(".single-popular-topic").addClass("selected");
    var handle = handelize(decodeURIComponent($(this).data("handle")));
    if (window.FaqObj.TopicsObj[handle] && window.FaqObj.TopicsObj[handle].length > 0) {
        $(".popular-topic-faqs .topic-title").html($(this).text());
        var arr = window.FaqObj.TopicsObj[handle];
        var Html = "";
        for (i = 0; i < arr.length; i++) {
            var yourArray = arr[i];
            Html += '<div class="single-searched-answer">';
            Html += '<div class="found-question">' + yourArray.question + "</div>";
            Html += '<div class="found-answer">' + yourArray.answer + "</div>";
            Html += "</div>";
        }
        $(".popular-topic-faqs").show();
        $(".popular-topic-faqs-list").html(Html);
        $("html, body").animate({
            scrollTop: $(".popular-topic-faqs").offset().top,
        }, 2000);
    } else {
        $(".popular-topic-faqs").hide();
    }
});
var regex = new RegExp("([!#-'*+/-9=?A-Z^-~-]+(.[!#-'*+/-9=?A-Z^-~-]+)*|\"([]!#-[^-~ \t]|(\\[\t -~]))+\")@([!#-'*+/-9=?A-Z^-~-]+(.[!#-'*+/-9=?A-Z^-~-]+)*|[[\t -Z^-~]*])");

function validateEmail(email) {
    return regex.test(email);
}
$(document).on("click", "#submit-alias", function(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    var formErrors = false;
    var elm = this;
    var form = $(elm).parents("form");
    $(".error").hide();
    var firstNameField = form.find('[name="contact[firstname]"]').val();
    if (firstNameField == "") {
        formErrors = true;
        $(".first-name-error").show().html("Please enter First Name");
    }
    var isEmailFieldValue = form.find("[type=email]").val();
    if (isEmailFieldValue == "") {
        $(".email-error").show().html("Please enter email address");
        formErrors = true;
    } else {
        var isValidEmail = validateEmail(isEmailFieldValue);
        if (isValidEmail) {
            formErrors = false;
        } else {
            $(".email-error").show().html("Please enter valid email");
            formErrors = true;
        }
    }
    var country = form.find('[name="contact[country]"]').val();
    if (country == "") {
        formErrors = true;
        $(".country-error").show().html("Please select country");
    }
    var message = form.find('[name="contact[Your Message]"]').val();
    if (message == "") {
        formErrors = true;
        $(".comment-error").show().html("Please add your message");
    }
    if (formErrors) {
        $("html, body").animate({
            scrollTop: $(this).parents("section").offset().top,
        }, 1000);
    } else {
        form.find("#submit-button-faq").click();
    }
});
$(document).on("click", ".field .dropbtn", function(evt) {
    evt.preventDefault();
    $(this).parents(".dropdown").find(".dropdown-content").slideToggle();
    $(this).toggleClass("opened");
});
$(document).on("click", ".dropdown-content .faq-selector a", function(evt) {
    evt.preventDefault();
    $(this).parents(".field").find("select").val($(this).attr("data-value")).trigger("change");
    $(this).parents(".dropdown").find(".select-text").text($(this).text()).addClass("selected");
    $(this).parents(".dropdown-content").slideToggle();
    $(this).parents(".dropdown").find(".dropbtn").removeClass("opened");
});
$("body").on("click", function(e) {
    if ($(e.target).parents(".dropdown").length == 0 && $(".dropdown-content:visible").length > 0) {
        $(".dropdown").find(".dropdown-content").fadeOut("slow");
        $(".field .dropbtn").removeClass("opened");
    }
});
/ Customer Accounts Pages/;
var regex = new RegExp("([!#-'*+/-9=?A-Z^-~-]+(.[!#-'*+/-9=?A-Z^-~-]+)*|\"([]!#-[^-~ \t]|(\\[\t -~]))+\")@([!#-'*+/-9=?A-Z^-~-]+(.[!#-'*+/-9=?A-Z^-~-]+)*|[[\t -Z^-~]*])");

function validateEmail(email) {
    return regex.test(email);
}
$(document).on("click", ".submit-alias", function(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    var formErrors = false;
    var elm = this;
    var form = $(elm).parents("form");
    form.find(".error").hide();
    var isEmailFieldValue = form.find("[type=email]").val();
    if (isEmailFieldValue == "") {
        form.find(".email-error").show().html("Please enter email address");
        formErrors = true;
    } else {
        var isValidEmail = validateEmail(isEmailFieldValue);
        if (isValidEmail) {
            formErrors = false;
        } else {
            form.find(".email-error").show().html("Please enter valid email");
            formErrors = true;
        }
    }
    if (form.find("[type=password]").length > 0) {
        var password = form.find("[type=password]").val();
        if (password == "") {
            formErrors = true;
            form.find(".pwd-error").show().html("Enter Password");
        }
    }
    if (formErrors) {
        // $("html, body").animate({
        //     scrollTop: $(this).parents(".customer").offset().top,
        // }, 1000);
    } else {
        form.find(".actual-submit").click();
    }
});
$(document).on("click", ".submit-alias-reset", function(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    var formErrors = false;
    var elm = this;
    var form = $(elm).parents("form");
    form.find(".error").hide();
    var password = form.find('[name="customer[password]"]').val();
    if (password == "") {
        formErrors = true;
        form.find(".pwd-error").show().html("Password Cant Be Blank");
    }
    var password2 = form.find('[name="customer[password_confirmation]"]').val();
    if (password2 == "") {
        formErrors = true;
        form.find(".pwd-error-2").show().html("Confirm Password Can't be Blank");
    }
    if (password != password2) {
        formErrors = true;
        form.find(".pwd-error-main").show().html("Password and Confirm Passwords are not same");
    }
    if (formErrors) {
        $("html, body").animate({
            scrollTop: $(this).parents(".customer").offset().top,
        }, 1000);
    } else {
        form.find(".actual-submit").click();
    }
});
// cart Page Scripts
if (window.isCart) {
    var interval = setInterval(doStuff, 2000);
}

function doStuff() {
    if (window.packagingOptions) {
        console.log(window.packagingOptions);
        var pack = "";
        window.packagingOptions.forEach(function(option, id) {
            var opt = "";
            var checked = window.handelize(window.cartNote).indexOf(window.handelize(option.title)) >= 0 ? "checked" : "";
            var label = "";
            label += '<div class="packaging-info">';
            label += '<div class="packaging-title">' + option.title + "</div>";
            label += '<div class="packaging-desc">' + option.desc + "</div>";
            label += "</div>";
            opt += '<div class="single-packaging-option">';
            opt += '<div class="packaging-radio-button">';
            opt += '<input type="radio" id="cart-note-cart-page--' + id + '" class="cart-note-cart-page" ' + checked + ' value="' + option.title + '" name="cart-note-cart-page" >';
            opt += '<label for="cart-note-cart-page--' + id + '">' + label + "</label>";
            opt += "</div>";
            opt += '<div class="packaging-image"><img src="' + option.image + '"></div>';
            opt += "</div>";
            pack += opt;
        });
        $(".packaging-options-cart-page").html(pack);
        clearInterval(interval);
    }
}
$(document).on("change", ".cart-note-cart-page", function() {
    var parent = $(this).parents(".cart-packaging-options-cart-page");
    var val = parent.find(".cart-note-cart-page:checked").val();
    $.ajax({
        type: "POST",
        url: window.routes.cart_update_url + ".js",
        dataType: "json",
        data: {
            note: "Eco Packaging Option : " + val,
        },
        success: function(cart) {
            location.reload();
        },
    });
});